import * as yup from "yup";
export const SitesSchema = yup.object().shape({
  SiteCode: yup.string().required().max(20),
  Name: yup.string().required().max(20),
  ContactFirstName: yup.string().required().max(20),
  ContactLastName: yup.string().required().max(20),
  ContactEmail: yup.string().required().email(),
  ContactPhone: yup.number().required().max(10),
  Comments: yup.string().max(50),
  Status: yup.boolean(),
});

export const ContactUsSchema = yup.object().shape({
  email: yup.string().label("Email"),
  name: yup.string().label("Name"),
  subject: yup.string().required().min(1).max(30).label("Subject"),
  description: yup.string().required().min(1).label("Description"),
});
